export const CandidatePreferences = () => {
  return null;
};

CandidatePreferences.displayName = 'CandidatePreferences';
